$(document).ready(function() {
  $(".zoom-btn").click(function(){
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      asNavFor: '.slider-nav'
    });

    $('.slider-nav').slick({
      slidesToShow: 5,
      asNavFor: '.slider-for',
      arrows: false,
      focusOnSelect: true,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,

      responsive: [

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }

      ]
    });
  });
  //   popup
  //  $('.zoom-btn').on('click',function(){

  //     	$('.popup').css('display','block');
  //         $('body').addClass('blur');

  //     });


  $('.close-popup').on('click',function(){

    $('.popup').css('display','none');
    $('body').removeClass('blur');

  });

  $('.closeMobilepopup').on('click',function(){
    $('.staticsearch_sidebar').css('display','none');
    $('body').removeClass('blur');
  });
});


function checkPosition() {
  if($(window).width() < 900)
  {
    $('.staticsearch_sidebar').css('display','block');
    $('body').addClass('blur');
  }

}



function showPopup(){

  $('.popup').css('display','block');
  $('body').addClass('blur');

}



$( document ).ready(function() {
    $(".modal-img-popup").click(function (e) {
        e.stopPropagation();
        return false;        
    });
});